// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M3.75736 7.75736C6.10051 5.41421 9.8995 5.41421 12.2426 7.75736C13.1589 8.67365 13.7169 9.81257 13.9166 11H22V13H20.5V15H18.5V13H17.5V15.9985H15.5V13H13.9166C13.7169 14.1874 13.1589 15.3264 12.2426 16.2426C9.8995 18.5858 6.10051 18.5858 3.75736 16.2426C1.41421 13.8995 1.41421 10.1005 3.75736 7.75736Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-key-filled')
export default class KeyFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'key-filled',
    }
  }
}
